<template>
  <require from="controls/as-page-jumbo.html"></require>
  <require from="controls/as-form-skeleton"></require>
  <require from="components/deviation-teams-panel"></require>

  <div class="admin-deviation-teams-screen">
    <as-page-jumbo icon="fas fa-users fa-fw" heading="Deviation teams administration" intro="Manage Deviation teams.">
    </as-page-jumbo>
    <form class="container-fluid">
      <div if.bind="loaded">
        <deviation-teams-panel repeat.for="deviationTeam of deviationTeams" deviation-team-detail-model.bind="deviationTeam" is-editing.bind="deviationTeam.isEditing"></deviation-teams-panel>
      </div>
      <as-form-skeleton else></as-form-skeleton>
    </form>
  </div>
</template>
